module.exports = __webpack_public_path__ + "static/img/logo-opacity.deb11eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-opacity.png
// module id = rxJN
// module chunks = 1